import $jsAPI from "../front_end_api";

const initPage = () => {

  if ($(".widget-products").length) {
    $(".pricing-select-product-cta").click(function() {
      if (window.products) {
        const productId = $(this).data('productId')
        const product = window.products.find(product => product.id == productId);
        $jsAPI.fireEvent('products:new_product_selected', product);
      }
    })
  }
};

$(initPage);
